import React, { useState } from 'react';
import { Table, Modal, Button, Form } from 'react-bootstrap';
import DeleteAppointmentModal from '../modals/deleteAppointmentModal';

const AntenatalTable = ({ data }) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;


  const openDeleteModal = (item) => {
    setShowDeleteModal(true);
    setSelectedAppointment(item);
  };

  const openDetailsModal = (item) => {
    setSelectedAppointment(item);
    setShowDetailsModal(true);
  };

  const antenatalData = [
    { id: 1, doctor: "Dr. Smith", dept: "Obstetrics", service_type: "Check-up",  date: "2025-03-15",  },
    { id: 2, doctor: "Dr. Johnson", dept: "Obstetrics", service_type: "Ultrasound", date: "2025-03-22", },
    { id: 3, doctor: "Dr. Adams", dept: "Gynecology", service_type: "Consultation", date: "2025-03-29", }
  ];

  const filteredData = antenatalData.filter(
    (item) =>
      item.doctor.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.dept.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.service_type.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.date.includes(searchTerm)
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

return (
    <>
    <Form.Control
            type="text"
            placeholder="Search..."
            className="mb-3"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ width: '250px' }}      
        />
    <Table striped hover className="align-middle">
                        <thead className='px-3'>
                            <tr className='px-3'>
                                <th>Doctor</th>
                                <th>Department</th>
                                <th>Service Type</th>
                                <th>Date</th>
                            </tr>
                        </thead>
                        <tbody className='px-5'>
                            {currentItems?.map((item) => (
                                <tr key={item.id} onClick={() => openDetailsModal(item)} className="py-3 border-bottom" style={{ cursor: 'pointer', height: '65px' }}>
                                    <td className="py-3 px-3">
                                        <div className="d-flex align-items-center gap-2">
                                            <div className="avatar border border-2 border-success text-info d-flex justify-content-center align-items-center">
                                                <i className="ri-information-line"></i>
                                            </div>
                                            <h6 className="mb-0">{item.doctor}</h6>
                                        </div>
                                    </td>
                                    <td className="py-3">{item.dept}</td>
                                    <td className="py-3">Antenatal</td>
                                    <td className="py-3">{item.appointment_type}</td>
                                    <td className="py-3">{item.date}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                    <div className="d-flex justify-content-between align-items-center mt-3">
                            <Button
                            variant="light"
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage(currentPage - 1)}
                            >
                            Previous
                            </Button>
                            <span>Page {currentPage} of {totalPages}</span>
                            <Button
                            variant="light"
                            disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage(currentPage + 1)}
                            >
                            Next
                            </Button>
                    </div>

        {/* Appointment Details Modal */}
        <Modal show={showDetailsModal} onHide={() => setShowDetailsModal(false)} centered>
            <Modal.Header closeButton>
                <Modal.Title>Appointment Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {selectedAppointment && (
                    <>
                        <p><strong>Doctor:</strong> {selectedAppointment.doctor}</p>
                        <p><strong>Department:</strong> {selectedAppointment.dept}</p>
                        <p><strong>Service Type:</strong> {selectedAppointment.service_type}</p>
                        <p><strong>Appointment Type:</strong> {selectedAppointment.appointment_type}</p>
                        <p><strong>Date:</strong> {selectedAppointment.date}</p>
                        <p><strong>Reason for Appointment:</strong> {selectedAppointment.reason_for_appointment}</p>
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowDetailsModal(false)}>Close</Button>
            </Modal.Footer>
        </Modal>

        {/* Delete Appointment Modal */}
        <DeleteAppointmentModal show={showDeleteModal} setShow={setShowDeleteModal} data={selectedAppointment} />
    </>
);
};

export default AntenatalTable;
